// Get client timezone from browser Intl API periodically
jQuery(function() {
    if (Cookies.get('browser_tz') == null) {
        document.cookie = "browser_tz=" + Intl.DateTimeFormat().resolvedOptions().timeZone + "; max-age=" + "43200;" + "path=/"; // max-age in seconds 43200 = 12h
    }
    // console.log(Cookies.get('browser_tz') == null);
})